import { toArray } from 'lodash'
import { mapLanguage } from 'Lib/i18nMiddleware'
import { SET_LANGUAGE } from './config'

export const TESTIMONIALS_FETCH_LIST_REQUEST =
  'TESTIMONIALS::FETCH_LIST_REQUEST'
export const TESTIMONIALS_FETCH_LIST_FAIL = 'TESTIMONIALS::FETCH_LIST_FAIL'
export const TESTIMONIALS_FETCH_LIST_SUCCESS =
  'TESTIMONIALS::FETCH_LIST_SUCCESS'

const initialState = { list: [], default: [], fetching: false }

export const fetchTestimonials = () => ({
  type: TESTIMONIALS_FETCH_LIST_REQUEST,
})

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TESTIMONIALS_FETCH_LIST_REQUEST: {
      return {
        ...state,
        fetching: true,
      }
    }
    case TESTIMONIALS_FETCH_LIST_SUCCESS: {
      return {
        ...state,
        list: toArray(action.data).map(mapLanguage(action.lang)),
        default: toArray(action.data),
        fetching: false,
      }
    }
    case TESTIMONIALS_FETCH_LIST_FAIL: {
      return {
        ...state,
        list: [],
        fetching: false,
      }
    }
    case SET_LANGUAGE: {
      return {
        ...state,
        list: state.default.map(mapLanguage(action.payload.lang)),
      }
    }
    default:
      return state
  }
}

export default reducer
